import { useEffect, useState } from 'react';
import { SessionExpiredError } from '../errors/SessionExpiredError';
import {
  recuperarOrdenPDF,
  reimprimirOrdenPDF,
  validarTokenOrdenPDF,
} from '../services/ordenPDFService';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

/**
 * Hook principal para el componente UploadTramitesSAT
 * Maneja carga automática de archivos, estados y submit final
 *
 * @param {Object} params - Parámetros del hook
 * @param {Function} params.setMessage - Función para mostrar mensajes al usuario
 * @returns {Object} Estado y métodos del componente
 */
const useVisorOrdenExterna = ({ setMessage }) => {
  // Token extraído de URL
  const { token } = useParams();

  // Estado del PDF recuperado
  const [pdfOrdenData, setPdfOrdenData] = useState(null);

  // Estado de carga inicial
  const [isLoading, setIsLoading] = useState(true);

  // Estado de error
  const [error, setError] = useState(null);

  // Estado de sesión expirada
  const [sessionExpired, setSessionExpired] = useState(null);

  /**
   * Carga los datos del trámite desde la API usando el token
   */
  useEffect(() => {
    const fetchGetOrdenData = async () => {
      if (!token) {
        const errorMsg = 'El enlace proporcionado no es válido o ha expirado.';
        setError(errorMsg);
        setIsLoading(false);
        setMessage({
          open: true,
          message: errorMsg,
          severity: 'error',
        });
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const fileURL = await recuperarOrdenPDF(token);
        setPdfOrdenData({ fileURL });
        setIsLoading(false);
      } catch (err) {
        console.error('Error al cargar datos del trámite:', err);

        if (err instanceof SessionExpiredError) {
          setSessionExpired(err.message);
          setIsLoading(false);
          return;
        }

        const errorMsg = 'No se pudo cargar el PDF de la orden.';
        setError(errorMsg);
        setIsLoading(false);
        setMessage({
          open: true,
          message: `Error al cargar el PDF de la orden: ${err.message}`,
          severity: 'error',
        });
      }
    };

    fetchGetOrdenData();
  }, [token]);

  return {
    // Estado
    pdfOrdenData,
    isLoading,
    error,

    // Estado de sesión expirada
    sessionExpired,
  };
};

export default useVisorOrdenExterna;
